
    import Vue from 'vue';
    import { PropType } from 'vue';
    import { Offer } from '@/apps/shared/models/offer';
    import InsurableAmount from '@/apps/shared/services/getInsurableAmount-service';
    import FamilyCombined from '@/apps/shared/services/familyCombinedQuotation-service';
    import DiscountRangeService from '@/apps/shared/services/getDiscountRange-service';
    import XBreadcrumb from '@/apps/shared/components/breadcrumb.vue';
    import CRMCotizadorWebService from '@/apps/shared/services/crm-service';
    import checkPricingService from '@/apps/shared/services/checkPricing-service';
    import genericModulePlanService from '@/apps/shared/services/getGenericModulePlan-service';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';
    import WhatsApp from '@/apps/shared/components/WhatsApp.vue';
    import { SaveMultiQuoteNotificationsRequest } from '@/apps/shared/models/saveMultiQuoteNotificationsRequest';

    export default Vue.extend({
        components: {
            XBreadcrumb,
            WhatsApp
        },
        name: 'Offer',
        props: {
            offer: {
                type: Object as PropType<Offer>,
                required: false,
            },
        },
        data() {
            return {
                data: [],
                selectedValue: null,
                QuotationJson: null,
                selectedPlan: null,
                col: 2,
                plansLength: null,
                covers: [],
                dataPlanQuotationComplete: [],
                breadcrumItems: [
                    { text: 'Inicio', path: '/hogar-premium' },
                    { text: 'Cotizá tu hogar', path: '/hogar-premium/cotizar' },
                    { text: 'Elegi Plan', path: '/hogar-premium/elegiPlan' },
                ],
                objectPlanCompleteWithCoverCapital: [],
                body: null,
                capitalPlan: 0,
                genericModulePlansWithoutPlan5: [],
                genericModulePlansComplete: [],
                tabTwoData: null,
                buildingCapitalSelected: null,
                securitySystem: [],
                selectedDiscounts: [],
                tabOneWelcome: null,
                tabFourData: null,
                referente: null,
                isOffer: false,
                offerVisible: true,
                pas: null,
                offerInsurableAmount: [0,0,0,0]
            }
        },
        methods: {
            async pageCustomization() {
                const defaultTitle = 'Hogar Premium';
                const actualPath = '/hogar-premium';
                let actualStep = 'quoted';

                if (this.offer) {
                    actualStep = 'stepOffer';
                }

                const request = new SaveMultiQuoteNotificationsRequest();
                request.lastName = this.tabOneWelcome.lastName;
                request.firstName = this.tabOneWelcome.firstName;
                request.phone = this.tabOneWelcome.areaCode + this.tabOneWelcome.telephone;
                request.mail = this.tabOneWelcome.email;
                request.quotePlan = this.objectPlanCompleteWithCoverCapital.map(plan => plan.planDescription).join(' - ');

                const securitySystemString = Array.isArray(this.securitySystem) && this.securitySystem.length > 0
                    ? this.securitySystem.join(', ')
                    : "No";

                request.quotationDetail = "Producto: " + defaultTitle
                    + " - Localidad: " + this.tabTwoData.selectedLocality.text
                    + " - Tipo: " + this.tabTwoData.articleCode.description.trim()
                    + " - M2: " + Number(this.tabTwoData.surfaceHouse).toLocaleString('es-AR')
                    + " - Valor: $" + Number(this.buildingCapitalSelected.code).toLocaleString('es-AR')
                    + " - Medidas Seguridad: " + securitySystemString;

                // Llamamos al helper que se encarga de toda la lógica
                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, actualStep, request);
                    const title = this.$store.getters.getWebSaleData?.pageCustomization?.navbar?.title ?? '';
                    this.pas = title === defaultTitle ? null : title;
                }
                catch (error) {
                    const statusCode = error.response.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },

            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultFamilyCombinedGTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },
            selectedPlans: function (quotationData) {
                var pricingId = quotationData.pricingId;
                sessionStorage.setItem("PlanSelected", JSON.stringify(quotationData));
                checkPricingService.checkStatePricing(pricingId).then(response => {
                    if (response.errorMessage == "Actualizacion correcta") {
                        const eventData = {
                            'pas': this.pas,
                            'email': this.tabOneWelcome.email,
                            'product': 'hogarPremium',
                            'event': 'cotizador-hogar-premium-plan',
                            'plan': quotationData.planDescription,
                            'referente': this.referente,
                            'medio': this.medium
                        };

                        window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                        window.globalThis.dataLayer.push(eventData);

                        const customWindow = window as typeof window & {
                            _qsie?: Array<typeof eventData>;
                        };

                        customWindow._qsie ??= [];
                        customWindow._qsie.push(eventData);

                        if (this.offer) {
                            this.tabTwoData.articleCode.text = quotationData.viviendaDesc;
                            this.tabTwoData.articleCode.description = quotationData.viviendaDesc;

                            sessionStorage.removeItem("TabTwoData");
                            sessionStorage.setItem("TabTwoData", JSON.stringify(this.tabTwoData));
                        }
                        this.$router.push({ name: 'FamilyHogarPremiumClientData' });
                    }
                    else {
                        const eventData = {
                            'pas': this.pas,
                            'email': this.tabOneWelcome.email,
                            'product': 'hogarPremium',
                            'event': 'errorServidor',
                            'paso': 'cotizador-hogar-premium-plan',
                            'referente': this.referente,
                            'medio': this.medium
                        };

                        window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                        window.globalThis.dataLayer.push(eventData);

                        const customWindow = window as typeof window & {
                            _qsie?: Array<typeof eventData>;
                        };

                        customWindow._qsie ??= [];
                        customWindow._qsie.push(eventData);
                    }
                });
            },
            volver() {
                sessionStorage.setItem("pressBack", "true");
                this.$router.push({
                    name: 'tabFourFamilyCombinedPremium',
                })
            },
            open: function () {
                this.$refs.modal.open();
            },
            close: function () {
                this.$refs.modal.close();
            },

            dataAmparos: function () {
                var DataQuotation = sessionStorage.getItem("DataQuotation");
                this.QuotationJson = JSON.parse(DataQuotation!);
                const PlanCount = this.QuotationJson.dataPlanQuotationComplete.length;

                var planComplete = this.QuotationJson.dataPlanQuotationComplete[PlanCount-1].finallyCalculationResults;
                var coverNotInclude = new Set([44, 45, 50, 51]);
                this.QuotationJson.dataPlanQuotationComplete.forEach(d => {
                    if (d.module == "1") {
                        var planWithModule1 = this.QuotationJson.dataPlanQuotationComplete.filter(o => o.module == d.module)
                        if (planWithModule1.length > 1) {
                            if (planWithModule1[0].premioMensual > planWithModule1[1].premioMensual) {
                                d.module = 2;
                                d.planDescription = "Plan 2";
                                d.planCode = 2;
                            }
                        }
                    }
                    else {
                        d.module = (parseInt(d.module) + 1).toString();
                        d.planDescription = "Plan " + d.module;
                        d.planCode = parseInt(d.planCode) + 1;
                    }
                    var plan = [];
                    d.covers.filter(o => !coverNotInclude.has(o.coverNumber)).forEach(c => {
                        var fcr = d.finallyCalculationResults.find(o => o.detalleInt == (c.coverNumber == 6 ? 1 : (c.coverNumber == 7 ? 2 : c.coverNumber)))
                        this.capitalPlan = 0;
                        if (fcr != null) {
                            this.capitalPlan = fcr.capital;
                        }
                        else {
                            if (planComplete.find(o => o.descripcion == c.description) != null) {
                                this.capitalPlan = planComplete.find(o => o.descripcion == c.description).capital
                            }
                        }
                        this.body =
                        {
                            capital: this.capitalPlan,
                            capitalFormatted: "$" + this.capitalPlan.toLocaleString(),
                            coverDescription: c.description,
                            coverNumber: c.coverNumber,
                            value: c.value,
                            tooltip: c.tooltip,
                            commercialDescriptId: c.commercialDescriptId,
                            planCode: d.planCode,
                            pricingId: d.pricingId
                        };
                        plan.push(this.body);
                    })
                    this.objectPlanCompleteWithCoverCapital.push(
                        {
                            pricingId: d.pricingId,
                            planCode: d.planCode,
                            planDescription: d.planDescription,
                            module: d.module,
                            plans: plan,
                            premioMensual: d.premioMensual,
                            premioMensualFormatted: d.premioMensualFormatted,
                            premioMensualSinDescuentoFormatted: d.premioMensualSinDescuentoFormatted,
                            planSelectionNotes: "",
                            suggestedPlan: "",
                            viviendaDesc: d.viviendaDesc
                        });

                })
                if (DataQuotation != null) {
                    this.objectPlanCompleteWithCoverCapital = this.objectPlanCompleteWithCoverCapital.sort((a, b) => a.premioMensual - b.premioMensual).filter(o => o.planCode != 5);
                    this.plansLength = this.objectPlanCompleteWithCoverCapital.length;
                    sessionStorage.setItem('dataPlanWithCoversCapital', JSON.stringify(this.objectPlanCompleteWithCoverCapital));
                    this.rate = this.QuotationJson.discountRate;
                }
                NF.UI.Page.unblock();
            },

            GetGenericModulePlan: function () {
                var productId = 927;
                genericModulePlanService.getGenericModulePlans(productId).then(response => {
                    this.genericModulePlansComplete = response;
                    this.genericModulePlansComplete = this.genericModulePlansComplete.filter(o => o.planCode != 5)
                    this.genericModulePlansWithoutPlan5 = response;
                    this.genericModulePlansWithoutPlan5 = this.genericModulePlansWithoutPlan5.filter(o => o.planCode != 2)

                    var a = (JSON.parse(sessionStorage.getItem("dataPlanWithCoversCapital")))
                    for (var i = 0; i < a.length; i++) {
                        this.objectPlanCompleteWithCoverCapital[i].planSelectionNotes = this.genericModulePlansComplete[i].planSelectionNotes;
                        if (this.isOffer) {
                            var planDescription = "Plan " + (i + 1);
                            this.objectPlanCompleteWithCoverCapital[i].planDescription = planDescription;
                            this.objectPlanCompleteWithCoverCapital[i].suggestedPlan = false;
                        }
                        else {
                            this.objectPlanCompleteWithCoverCapital[i].suggestedPlan = this.genericModulePlansComplete[i].suggestedPlan;
                        }
                    }
                    sessionStorage.setItem('dataPlanWithCoversCapital', JSON.stringify(this.objectPlanCompleteWithCoverCapital));
                });
            },
            InitTabsOffer() {
                const OffersSettings = JSON.parse(this.offer.OffersSettings);
                this.tabOneWelcome = {
                    firstname: "aaa",
                    lastname: "bbb",
                    areaCode: "",
                    telephone: "",
                    email: ""
                };
                sessionStorage.setItem("TabOneWelcome", JSON.stringify(this.tabOneWelcome));
                this.tabTwoData = {
                    articleCode: {
                        "text": "Vivienda",
                        "article": OffersSettings.Tipo_de_vivienda[0],
                        "description": "Vivienda",
                        "id": OffersSettings.Tipo_de_vivienda[0]
                    },
                    surfaceHouse: OffersSettings.Metros_cuadrados[0],
                    selectedLocality: {
                        text: "(" + OffersSettings.Codigo_Postal + ") " + OffersSettings.Ciudad + " (" + OffersSettings.Provincia + ")",
                        id: OffersSettings.CityId,
                        "zipCode": OffersSettings.Codigo_Postal,
                        "name": OffersSettings.Ciudad,
                        "provinceName": OffersSettings.Provincia,
                        "localityFormatted": null
                    },
                    buildTypeCode: null,
                    buildingSurfaceMin: 40,
                    buildingSurfaceMax: 800
                };
                sessionStorage.setItem("TabTwoData", JSON.stringify(this.tabTwoData));
                this.buildingCapitalSelected = {
                    "productDescription": "$ " + OffersSettings.Valor_de_la_vivienda[0],
                    "code": OffersSettings.Valor_de_la_vivienda[0],
                    "categoryId": OffersSettings.Tipo_de_construccion[0],
                    "fromTab": "tab-three"
                };
                sessionStorage.setItem("ProductValueSelected", JSON.stringify(this.buildingCapitalSelected));
                this.tabFourData = {
                    "Discount20": OffersSettings.Sistema_de_deteccion_de_incendios,
                    "Discount21": OffersSettings.Personal_de_vigilancia,
                    "Discount22": OffersSettings.Puertas_blindadas,
                    "Discount23": OffersSettings.Alarma_contra_robo_monitoreada
                };
                sessionStorage.setItem("TabFourData", JSON.stringify(this.tabFourData));
                this.systemSecurity = [];
                if (OffersSettings.Sistema_de_deteccion_de_incendios) {
                    this.systemSecurity.push("Sistema de detección de incendios");
                    this.selectedDiscounts.push(20)
                }
                if (OffersSettings.Personal_de_vigilancia) {
                    this.systemSecurity.push("Personal de vigilancia");
                    this.selectedDiscounts.push(21)
                }
                if (OffersSettings.Puertas_blindadas) {
                    this.systemSecurity.push("Puertas blindadas");
                    this.selectedDiscounts.push(22)
                }
                if (OffersSettings.Alarma_contra_robo_monitoreada) {
                    this.systemSecurity.push("Alarma contra robo monitoreada");
                    this.selectedDiscounts.push(23)
                }
                this.securitySystem = this.systemSecurity;
                sessionStorage.setItem("SecuritySystem", JSON.stringify(this.securitySystem));
            },
            async cotizarOffers(responseFamilyCombined927Quotation) {
                const OffersSettings = JSON.parse(this.offer.OffersSettings);
                this.dataPlanQuotationComplete = responseFamilyCombined927Quotation.dataPlanQuotationComplete;

                const count = OffersSettings.Tipo_de_vivienda.length;
                const requests: Promise<any>[] = [];

                for (let i = 1; i < count; i++) {
                    const body = JSON.stringify({
                        buildingCapital: parseInt(this.offerInsurableAmount[i]),
                        buildTypeCode: OffersSettings.Tipo_de_construccion[i],
                        articleCode: parseInt(OffersSettings.Tipo_de_vivienda[i]),
                        cityId: parseInt(this.tabTwoData.selectedLocality.id),
                        zipCode: this.tabTwoData.selectedLocality.zipCode,
                        surfaceHouse: parseInt(OffersSettings.Metros_cuadrados[i]),
                        email: this.tabOneWelcome.email,
                        areaCode: this.tabOneWelcome.areaCode,
                        telephone: this.tabOneWelcome.telephone,
                        selectedDiscounts: this.selectedDiscounts,
                        productId: 927,
                        coverCode: 301,
                        quotationId: responseFamilyCombined927Quotation.quotationId,
                        coverModuleCodes: String(OffersSettings.Modulo[i]),
                        deductibleOption: parseInt(OffersSettings.Deducible[i]),
                        relationId: responseFamilyCombined927Quotation.relationId,
                    });

                    requests.push(FamilyCombined.createFamilyCombined927Quotation(body));
                }

                const responses = await Promise.all(requests);

                for (const res of responses) {
                    this.dataPlanQuotationComplete.push(res.dataPlanQuotationComplete[0]);
                }

                responses[0].dataPlanQuotationComplete = this.dataPlanQuotationComplete;

                FamilyCombined.setSessionFamilyCombinedPremiumQuotationPlan(responses[0]);
            },
            getInitData() {
                sessionStorage.setItem("ExitOrContinueModal", "true");
                if (this.offer) {
                    const OffersSettings = JSON.parse(this.offer.OffersSettings);
                    var body = JSON.stringify({
                        buildingCapital: parseInt(this.offerInsurableAmount[0]),
                        buildTypeCode: OffersSettings.Tipo_de_construccion[0],
                        articleCode: parseInt(OffersSettings.Tipo_de_vivienda[0]),
                        cityId: parseInt(this.tabTwoData.selectedLocality.id),
                        zipCode: this.tabTwoData.selectedLocality.zipCode,
                        surfaceHouse: parseInt(OffersSettings.Metros_cuadrados[0]),
                        email: this.tabOneWelcome.email,
                        areaCode: this.tabOneWelcome.areaCode,
                        telephone: this.tabOneWelcome.telephone,
                        selectedDiscounts: this.selectedDiscounts,
                        productId: 927,
                        coverCode: 301,
                        coverModuleCodes: String(OffersSettings.Modulo[0]),
                        deductibleOption: OffersSettings.Deducible[0],
                    });
                    FamilyCombined.createFamilyCombined927Quotation(body).then(async responseFamilyCombined927Quotation => {
                        this.cotizarOffers(responseFamilyCombined927Quotation).then(() => {
                            responseFamilyCombined927Quotation.dataPlanQuotationComplete = this.dataPlanQuotationComplete;
                            sessionStorage.removeItem("DataQuotation");
                            sessionStorage.setItem("DataQuotation", JSON.stringify(responseFamilyCombined927Quotation));
                            sessionStorage.setItem("Producto:Hogar Premium", JSON.stringify(responseFamilyCombined927Quotation));
                            window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                            sessionStorage.removeItem("pressBack");
                            var fromTabPassFour = sessionStorage.getItem("FromTabPassFour");
                            var fromTabFive = sessionStorage.getItem("FromTabFive");
                            this.dataAmparos();
                            this.GetGenericModulePlan();
                            this.offerVisible = true;
                            NF.UI.Page.unblock();
                        });
                    });
                }
                else {
                    this.tabOneWelcome = JSON.parse(sessionStorage.getItem("TabOneWelcome"));
                    this.tabTwoData = JSON.parse(sessionStorage.getItem("TabTwoData"));
                    this.buildingCapitalSelected = JSON.parse(sessionStorage.getItem("ProductValueSelected"));
                    this.tabFourData = JSON.parse(sessionStorage.getItem("TabFourData"));
                    this.securitySystem = JSON.parse(sessionStorage.getItem("SecuritySystem"));;
                    this.leadId = JSON.parse(sessionStorage.getItem("LeadId"));
                    const additionalInformation = {
                        'Tipo de vivienda': this.tabTwoData.articleCode.description,
                        'Metros': this.tabTwoData.surfaceHouse,
                        'Suma asegurada elegida': this.buildingCapitalSelected.code.toString(),
                        'Sistema de detección de incendios': (this.tabFourData == null) ? 'false' : this.tabFourData["Discount20"].toString(),
                        'Personal de vigilancia': (this.tabFourData == null) ? 'false' : this.tabFourData["Discount21"].toString(),
                        'Puertas blindadas': (this.tabFourData == null) ? 'false' : this.tabFourData["Discount22"].toString(),
                        'Alarma contra robo monitoreada': (this.tabFourData == null) ? 'false' : this.tabFourData["Discount23"].toString(),
                        'Localidad': this.tabTwoData.selectedLocality.name,
                    };
                    CRMCotizadorWebService.CreateOrEditLead(this.leadId, this.tabOneWelcome.email, location.href, this.tabOneWelcome.areaCode, this.tabOneWelcome.telephone, 927, false, "5", additionalInformation, this.tabOneWelcome.lastName, this.tabOneWelcome.name);

                    window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                    sessionStorage.removeItem("pressBack");
                    var fromTabPassFour = sessionStorage.getItem("FromTabPassFour");
                    var fromTabPassFour = sessionStorage.getItem("FromTabPassFour");
                    var fromTabFive = sessionStorage.getItem("FromTabFive");
                    this.dataAmparos();
                    this.GetGenericModulePlan();
                }

                if (fromTabPassFour == "true" && fromTabFive == "true") {
                    sessionStorage.setItem("FromTabPassFour", "false");
                } else {
                    if (fromTabPassFour == "false" && fromTabFive == "true") {
                        sessionStorage.setItem("FromTabFive", "false");
                        sessionStorage.setItem("FromTabPassFour", "true");
                    } else {
                        sessionStorage.setItem("FromTabPassFour", "false");
                        sessionStorage.setItem("FromTabFive", "true");
                    }
                }
            },
            async getInsurableAmount() {
                const OffersSettings = JSON.parse(this.offer.OffersSettings);
                const count = OffersSettings.Tipo_de_vivienda.length;

                const promises: Promise<void>[] = [];

                for (let i = 0; i < count; i++) {
                    if (OffersSettings.Valor_de_la_vivienda[i] === 0) {
                        const articleCode = Number(OffersSettings.Tipo_de_vivienda[i]);
                        const surfaceHouse = Number(OffersSettings.Metros_cuadrados[i]);

                        const p = InsurableAmount
                            .getInsurableAmount(articleCode, surfaceHouse)
                            .then((response: any[]) => {
                                const categoryToFind = Number(OffersSettings.Tipo_de_construccion[i]);
                                const found = response.find(item => item.category === categoryToFind);

                                this.offerInsurableAmount[i] = found ? Number(found.amount ?? found.value ?? 0) : 0;
                            });

                        promises.push(p);
                    } else {
                        this.offerInsurableAmount[i] = parseInt(OffersSettings.Valor_de_la_vivienda[i], 10);
                    }
                }

                await Promise.all(promises);
            }

        },
        async mounted() {
            try {                
                var referente = sessionStorage.getItem("Referente");
                referente == 'null' || referente == null ? this.referente = null : this.referente = referente;
                var medium = sessionStorage.getItem("Medium");
                medium == 'null' || medium == null ? this.medium = 'organic' : this.medium = medium;

                if (this.offer) {
                    this.offerVisible = false;
                    NF.UI.Page.block({
                        message: [
                            {
                                text: "Estamos buscando tu mejor cotización...",
                                spin: '<i class="fa fa-asterisk fa-spin fa-3x"></i>',
                            },
                            {
                                text: "Comparando coberturas y precios…",
                                spin: '<i class="fa fa-circle-o-notch fa-spin fa-3x"></i>',
                            },
                            {
                                text: "Casi listo.Estamos confirmando tu mejor cotización…",
                                spin: '<i class="fa fa-asterisk fa-spin fa-3x"></i>',
                            }
                        ]
                    });
                    await this.getInsurableAmount();
                    const rutaAlternativa = sessionStorage.getItem("rutaAlternativa");
                    sessionStorage.clear();
                    this.isOffer = true;
                    this.InitTabsOffer();
                    this.pageCustomization().then(() => {
                        DiscountRangeService.getFamilyCombinedDiscountRange().then(() => {
                            sessionStorage.setItem("rutaAlternativa", rutaAlternativa);
                            this.getInitData();
                            this.updateByProductGoogleAnalytics();
                        });
                    });
                }
                else {
                    NF.UI.Page.block();

                    const parallelPromises = [
                        this.getInitData(),
                        this.updateByProductGoogleAnalytics()
                    ];

                    await Promise.all([
                        ...parallelPromises,
                    ]);

                    this.pageCustomization();

                    NF.UI.Page.unblock();
                }

            } catch {
                NF.UI.Page.unblock();
            }
        },
    })
